module.exports = __webpack_public_path__ + "Check.png";